import React, { useState } from 'react';
import Accordion from './Accordion';
import FovOriginHelpModal from './FovOriginHelpModal';

const GEOMETRY_TYPES = {
  LAMINOGRAPHY: 'laminography',
  LAMINOGRAPHY_SOURCE_PERP: 'laminography_source_perp',
  TOMOGRAPHY: 'tomography',
};

function GeometrySelector({ value, onChange, params, onParamsChange }) {
  const [showHelpModal, setShowHelpModal] = useState(false);

  const handleCheckboxChange = (e) => {
    onParamsChange({ ...params, fovCenterAsOrigin: e.target.checked });
  };

  return (
    <div className="form-section geometry-selector">
      <Accordion title="Geometry" defaultOpen={true}>
        <div className="form-group">
          <label>Setup</label>
          <select value={value} onChange={(e) => onChange(e.target.value)}>
            <option value={GEOMETRY_TYPES.TOMOGRAPHY}>
              Tomography
            </option>
            <option value={GEOMETRY_TYPES.LAMINOGRAPHY}>
              Laminography
            </option>
            <option value={GEOMETRY_TYPES.LAMINOGRAPHY_SOURCE_PERP}>
              Laminography - Source Perpendicular to Origin
            </option>
          </select>
        </div>

        {value === GEOMETRY_TYPES.LAMINOGRAPHY_SOURCE_PERP && (
          <div className="checkbox-with-help">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={params.fovCenterAsOrigin}
                onChange={handleCheckboxChange}
              />
              FOV center as origin
            </label>
            <button
              className="help-btn"
              onClick={() => setShowHelpModal(true)}
              aria-label="Help"
            >
              ?
            </button>
          </div>
        )}
      </Accordion>

      <FovOriginHelpModal
        isOpen={showHelpModal}
        onClose={() => setShowHelpModal(false)}
      />
    </div>
  );
}

export { GEOMETRY_TYPES };
export default GeometrySelector;
